import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Smartphone, BellRing, Users } from "lucide-react";

const Stat = ({ icon: Icon, label, value, testid, tone }) => (
  <div className="flex items-center gap-3">
    <div className="rounded-lg p-2" style={{ background: `${tone}1F`, color: tone }}><Icon className="h-4 w-4" /></div>
    <div>
      <div data-testid={testid} className="font-mono text-xl font-bold text-white">{value}</div>
      <div className="text-[11px] text-slate-500">{label}</div>
    </div>
  </div>
);

export const AppStatsCard = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/chat-stats").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <div data-testid="app-stats-card" className="rounded-2xl border border-[#D4FF3A]/25 bg-[#111827] p-4 fade-up">
      <div className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-[#D4FF3A]">
        <Smartphone className="h-4 w-4" /> App de suporte
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        <Stat icon={Smartphone} label="clientes com app instalado" value={d.clients_installed} testid="app-stats-installed" tone="#D4FF3A" />
        <Stat icon={BellRing} label="clientes com avisos ativos" value={d.clients_push} testid="app-stats-push" tone="#34D399" />
        <Stat icon={Users} label="clientes que já usaram o chat" value={d.clients_chat} testid="app-stats-chat" tone="#38BDF8" />
        <Stat icon={Users} label={`leads no chat (${d.leads_installed} com app)`} value={d.leads} testid="app-stats-leads" tone="#FBBF24" />
      </div>
    </div>
  );
};
